import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

// Components
import Video from "../components/Video/video"
import Headline from "../components/Headline/headline"
import Pullquotes from "../components/Pullquotes/pullquotes"
import Watch from "../components/Watch/watch"
// import Synopsis from "../components/Synopsis/Synopsis"
import About from "../components/About/about"
// import Media from "../components/Media/media"
// import Updates from "../components/Updates/updates"
// import VideoFull from "../components/Video-Full/video-full"

// Images
import background from '../images/flowers.jpg'

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Video />
    <Pullquotes />
    <section className="mt-20" 
      style={{ 
        backgroundImage: `url(${background})`, 
        backgroundRepeat: 'no-repeat', 
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        height: '350px'
      }}
    ></section>
    <Headline />
    <About />
    <Watch />
    <section>
      <div className="container mx-auto max-w-screen-lg px-5 pb-20">
        <h1 className="text-3xl font-heading mb-4">Support Future Projects</h1>
        <p className="mb-12 text-lg max-w-screen-sm">Social support involves the sharing of good times, and the giving and receiving of help through the rough times</p>
        <a className="inline-block border px-8 py-3 rounded-lg border-gray-900 font-heading text-lg" href="#0">Support Us</a>
      </div>
    </section>
  </Layout>
)

export default IndexPage
